import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RefundPaymentDialogComponent } from './refund-payment-dialog.component';
import { DialogsService } from '../../../../../core/services/dialog.service';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [RefundPaymentDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
    MatExpansionModule,
  ],
  entryComponents: [RefundPaymentDialogComponent],
  providers: [DialogsService],
  exports: [RefundPaymentDialogComponent],
})
export class RefundPaymentDialogModule {}
